import React, { useEffect, useRef, useState } from "react";
import ORBApi from "../../../../services/ORBApi";
import * as moment from "moment";
import {
  Tooltip,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  TableContainer,
  TableCell,
  Table,
  TableHead,
  TableBody,
  TableRow,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import Loading from "../../../../components/common/Loading";
import excelLogo from "../../../../assets/excel-logo.png";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import UpdateRoundedIcon from "@mui/icons-material/UpdateRounded";
import BackupRoundedIcon from "@mui/icons-material/BackupRounded";
import DateMonthPicker from "../../../../components/common/DateMonthPicker";
import { getFormatBySource } from "../../../../utils/ReportSourceUtils";
import ProgressBar from "../../../../components/common/ProgressBar";

export function AddFilePanelCompanies({ onSave }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [lastFile, setLastFile] = useState(null);
  const [reportData, setReportData] = useState({
    month: "",
    currency: "",
    report_source: "",
    comma_as_decimal_sep: "",
    show_exchange_rate: false,
  });
  const [checked, setChecked] = useState(false);
  const [validateForm, setValidateForm] = useState(false); // when true shows the error on fields
  const [processing, setProcessing] = useState(false); // used to show loading
  const [uploadedReportId, setUploadedReportId] = useState(null); // ID do relatório após upload
  const [progressData, setProgressData] = useState(null); // Dados de progresso
  const [importError, setImportError] = useState(null); // Mensagem de erro do import
  const pollingIntervalRef = useRef(null); // Ref estável — evita stale closure no fetchProgress

  const isFormValid = () => {
    setValidateForm(true);
    if (
      !selectedFile ||
      reportData.month === "" ||
      reportData.currency === "" ||
      reportData.report_source === "" ||
      (reportData.comma_as_decimal_sep !== 0 &&
        reportData.comma_as_decimal_sep !== 1 &&
        reportData.comma_as_decimal_sep !== "0" &&
        reportData.comma_as_decimal_sep !== "1")
    )
      return false;

    return true;
  };

  const OptionsFont = [
    { value: 1, label: "Believe" },
    { value: 2, label: "TheOrchard" },
    { value: 3, label: "OneRPM" },
    { value: 4, label: "Ingrooves" },
    // { value: 5, label: "Altafonte" },
    { value: 6, label: "FUGA" },
    { value: 7, label: "Ingrooves USA" },
    { value: 8, label: "Universal Music" },
    // { value: 9, label: "SomLivre" },
    // { value: 10, label: "Symphonic" },
    // { value: 11, label: "CmdShift" },
    // { value: 12, label: "Universal2" }, // consolidado em "Universal Music" (id 8)
    { value: 13, label: "Believe2" },
    { value: 14, label: "Virgin" },
    { value: 15, label: "Vydia" },
  ];

  const SortOptionsFonts = OptionsFont.sort((a, b) =>
    a.label.localeCompare(b.label)
  );

  // Função para iniciar polling de progresso
  const startProgressPolling = (reportId) => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    fetchProgress(reportId);

    pollingIntervalRef.current = setInterval(() => {
      fetchProgress(reportId);
    }, 2000);
  };

  // Função para buscar progresso do relatório
  const fetchProgress = async (reportId) => {
    try {
      const data = await ORBApi.getPaymentReportStatus(reportId);
      setProgressData(data);

      // Se processamento concluído ou erro, para polling
      if (data.status === 2 || data.status === -1) {
        // LOADED (2) ou ERROR (-1)
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
        if (data.status === -1) {
          setImportError(data.error_message || "Erro ao processar o arquivo.");
          setProcessing(false);
        }
        // Se for LOADED, o ProgressBar chamará onComplete após 1500ms
      }
    } catch (error) {
      console.error("Erro ao buscar progresso:", error);
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
      onSave(true);
      setProcessing(false);
    }
  };

  // Callback chamado pelo ProgressBar após delay de conclusão
  const handleProgressComplete = () => {
    onSave(true);
    setProcessing(false);
  };

  // Limpa polling quando componente desmonta
  useEffect(() => {
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, []);

  const uploadForm = () => {
    if (!isFormValid()) return;
    setProcessing(true);

    //Mount the posting body
    var formData = new FormData();
    formData.append("report_file", selectedFile);
    formData.append("month", moment(reportData.month).format("YYYY-MM"));
    formData.append("report_source", reportData.report_source);
    formData.append("currency", reportData.currency);
    formData.append("comma_as_decimal_sep", reportData.comma_as_decimal_sep);
    formData.append(
      "show_exchange_rate",
      reportData.show_exchange_rate === true ? 0 : 1
    );

    if (lastFile && reportData.report_source === 8) {
      formData.append("previous_report_file", lastFile);
    }
    ORBApi.postPaymentReports(formData)
      .then((response) => {
        // Tenta obter o ID do relatório da resposta
        const reportId = response?.id || response?.result?.id;
        if (reportId) {
          setUploadedReportId(reportId);
          startProgressPolling(reportId);
        } else {
          // Se não tiver ID na resposta, busca da lista de relatórios
          // Aguarda um pouco para o relatório aparecer na lista
          setTimeout(() => {
            ORBApi.loadPaymentReports(1, {})
              .then((data) => {
                if (data.reports && data.reports.length > 0) {
                  // Pega o primeiro relatório (mais recente)
                  const latestReport = data.reports[0];
                  if (latestReport && latestReport.id) {
                    setUploadedReportId(latestReport.id);
                    startProgressPolling(latestReport.id);
                  } else {
                    onSave(true);
                    setProcessing(false);
                  }
                } else {
                  onSave(true);
                  setProcessing(false);
                }
              })
              .catch(() => {
                onSave(true);
                setProcessing(false);
              });
          }, 1000);
        }
      })
      .catch(() => {
        onSave(false);
        setProcessing(false);
      });
  };

  return (
    <>
      <h4 className="title"> Carregar arquivo agregadora</h4>
      <hr />
      <Grid container spacing={2} alignItems="center">
        {/* First row: Mês Referência, Moeda, Fonte, Formato */}
        <Grid
          item
          md={3}
          xs={12}
          style={{ display: "flex", alignItems: "flex-start" }}
        >
          <div style={{ width: "100%" }}>
            <DateMonthPicker
              label="Mês Referência"
              error={validateForm && !reportData.month}
              format="MM/yyyy"
              view={["month", "year"]}
              required
              value={reportData.month}
              onChange={(month) => {
                setReportData({ ...reportData, month: month });
              }}
            />
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <FormControl
            className="form-select"
            style={{ width: "100%", paddingTop: "8px" }}
            required
            error={validateForm && !reportData.currency ? true : null}
          >
            <InputLabel className="select-label">Moeda</InputLabel>
            <Select
              native
              label="Moeda"
              onChange={(e) =>
                setReportData({ ...reportData, currency: e.target.value })
              }
              variant="outlined"
            >
              <option value="" />
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="BRL">BRL</option>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={3} xs={12}>
          <FormControl
            className="form-select"
            style={{ width: "100%", paddingTop: "8px" }}
            required
            error={validateForm && !reportData.report_source ? true : null}
          >
            <InputLabel className="select-label"> Fonte </InputLabel>
            <Select
              native
              label="Fonte"
              onChange={(e) => {
                const selectedSource = e.target.value;
                const autoFormat = getFormatBySource(selectedSource);
                setReportData({
                  ...reportData,
                  report_source: selectedSource,
                  comma_as_decimal_sep: autoFormat,
                });
              }}
              variant="outlined"
            >
              <option aria-label="None" value="" />

              {SortOptionsFonts.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={3} xs={12}>
          <FormControl
            className="form-select"
            style={{ width: "100%", paddingTop: "8px" }}
            required
            error={
              validateForm &&
              reportData.comma_as_decimal_sep !== 0 &&
              reportData.comma_as_decimal_sep !== 1 &&
              reportData.comma_as_decimal_sep !== "0" &&
              reportData.comma_as_decimal_sep !== "1"
                ? true
                : null
            }
          >
            <InputLabel className="select-label"> Formato </InputLabel>
            <Select
              native
              label="Formato"
              value={reportData.comma_as_decimal_sep}
              disabled
              variant="outlined"
            >
              <option aria-label="None" value="" />
              <option value={0}>Americano (".")</option>
              <option value={1}>Brasileiro (",")</option>
            </Select>
          </FormControl>
        </Grid>

        {/* Second row: Selecionar arquivo, Esconder taxas */}
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center", gap: "32px" }}
        >
          <div
            className="form-item-container clickable"
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              document.getElementById("real-file").click();
            }}
          >
            <input
              id="real-file"
              type="file"
              hidden="hidden"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
            <BackupRoundedIcon
              className="upload-icon"
              fontSize="large"
              color="secondary"
            />
            <span
              className={
                !selectedFile && validateForm
                  ? "error panel-options-texts"
                  : "panel-options-texts"
              }
            >
              {selectedFile
                ? selectedFile.name
                : "Selecione um arquivo de pagamentos..."}
            </span>
          </div>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={(e) => {
                  setReportData({
                    ...reportData,
                    show_exchange_rate: !checked,
                  });
                  setChecked(!checked);
                }}
              />
            }
            label={
              <Typography variant="body1" style={{ fontSize: ".8rem" }}>
                Esconder taxas de câmbio
              </Typography>
            }
          />
        </Grid>

        {reportData.report_source === 8 ? (
          <>
            <Grid item xs={12} md={12} style={{ display: "flex" }}>
              <div
                className="form-item-container clickable"
                style={{ width: "100%", cursor: "pointer" }}
                onClick={() => {
                  document.getElementById("last-file").click();
                }}
              >
                <input
                  id="last-file"
                  type="file"
                  hidden="hidden"
                  onChange={(e) => setLastFile(e.target.files[0])}
                />
                <BackupRoundedIcon
                  className="upload-icon"
                  fontSize="large"
                  color="secondary"
                />
                <span>
                  {lastFile
                    ? lastFile.name
                    : "Selecione o arquivo predecessor..."}
                </span>
              </div>
            </Grid>
          </>
        ) : null}

        {/* Third row: Enviar button centralized */}
        <Grid item xs={12}>
          <div
            className="form-item-container"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "16px",
            }}
          >
            {processing ? (
              <Loading />
            ) : (
              <Button
                variant="contained"
                color="secondary"
                onClick={uploadForm}
                size="large"
                style={{ minWidth: "300px" }}
              >
                Enviar
              </Button>
            )}
          </div>
        </Grid>
        {/* Barra de progresso durante processamento */}
        {progressData && (
          <Grid item xs={12}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div style={{ width: "100%", maxWidth: "600px" }}>
                {importError ? (
                  <div style={{ color: "#d32f2f", fontSize: "0.85rem", wordBreak: "break-word" }}>
                    <strong>Erro no arquivo:</strong> {importError}
                  </div>
                ) : (
                  <ProgressBar
                    processedRows={progressData.processed_rows || 0}
                    totalRows={progressData.total_rows || 0}
                    progressPercent={progressData.progress_percent || 0}
                    status={
                      progressData.status === 2
                        ? "LOADED"
                        : progressData.status === -1
                        ? "ERROR"
                        : "LOADING"
                    }
                    onComplete={handleProgressComplete}
                  />
                )}
              </div>
            </div>
          </Grid>
        )}
      </Grid>
    </>
  );
}

export function DeletionConfirmPanel({ report, onConfirm }) {
  const [isProcessing, setIsProcessing] = useState(false);

  const doDeleteFile = () => {
    setIsProcessing(true);
    ORBApi.deletePaymentReports(report.id)
      .then(() => {
        onConfirm(true);
      })
      .catch(() => {
        onConfirm(false);
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  return (
    <>
      <h5>Deseja realmente remover este arquivo?</h5>
      <div className="deletion-subtitle">
        ({report.month} {report.source})
      </div>
      {isProcessing ? (
        <div className="loading-container">
          <Loading />{" "}
        </div>
      ) : (
        <div className="action-button-container">
          <Button variant="contained" color="secondary" onClick={doDeleteFile}>
            Confirmar
          </Button>
        </div>
      )}
    </>
  );
}

export function UpdateStatusConfirmPanel({
  report_id,
  loadData,
  current_page,
  setStatusVisible,
}) {
  const [loading, setLoading] = useState(0);

  const updateStatus = () => {
    let body = { status: 4 };
    setLoading(1);
    ORBApi.updatePaymentDetails(report_id, body)
      .then(() => {
        toast.success("Status atualizado !");
        loadData(current_page);
      })
      .catch((error) => {
        toast.error("Erro ao atualizar status.");
      })
      .finally(() => {
        setLoading(0);
        setStatusVisible(false);
      });
  };

  return (
    <>
      <h5>Deseja atualizar o status do arquivo?</h5>
      <div className="action-button-container">
        {loading ? (
          <Loading size="24px" />
        ) : (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => updateStatus()}
          >
            Confirmar
          </Button>
        )}
      </div>
    </>
  );
}

export function RateEditPanel({ report, onSave }) {
  const [currencies, setCurrencies] = useState([]);
  const [currenciesToUpdate, setCurrenciesToUpdate] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    ORBApi.loadPaymentReportCurrencies(report).then(setCurrencies);
  }, [report]);

  const onTextChangeHandler = (value, currency) => {
    let original = currenciesToUpdate;
    original[currency] = parseFloat(value);
    setCurrenciesToUpdate(original);
  };

  const updateCurrencies = async () => {
    setIsProcessing(true);
    const keys = Object.keys(currenciesToUpdate);
    if (keys.length === 0) {
      toast.warn("Preencha um valor");
      setIsProcessing(false);
      return;
    }

    // validate values
    for (const k of keys) {
      const v = currenciesToUpdate[k];
      if (v === undefined || v === null || v === "" || isNaN(v)) {
        toast.warn("Preencha um valor");
        setIsProcessing(false);
        return;
      }
    }

    try {
      const promises = keys.map((currency) =>
        ORBApi.updatePaymentReportCurrency(
          report,
          currency,
          currenciesToUpdate[currency]
        )
      );
      await Promise.all(promises);
      onSave();
    } catch (err) {
      // if any request fails we still inform the caller
      onSave(false);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <h6 className="title">Taxas de câmbio para edição</h6>
      <Grid container spacing={2} alignItems="center">
        {currencies.map((currency, key) => {
          return (
            <Grid item md={6} key={currency.currency}>
              <TextField
                onChange={(e) =>
                  onTextChangeHandler(e.target.value, currency.currency)
                }
                label={currency.currency}
                defaultValue={currency.exchange_rate}
                variant="outlined"
                type="number"
              />
            </Grid>
          );
        })}
        {isProcessing ? (
          <Loading size="25px" />
        ) : (
          <Grid item md={4} key="btn">
            <Button
              onClick={updateCurrencies}
              variant="contained"
              color="secondary"
              size="large"
            >
              {" "}
              Salvar{" "}
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
}

export function NotFoundTracksPanel({ report, onDownload }) {
  const [tracksData, setTracksData] = useState({
    tracks: [],
    pages: 0,
    current_page: 0,
    total_items: 0,
  });
  const [downloading, setDownloading] = useState(false);
  const [rebuilding, setRebuilding] = useState(false);

  const downloadExcel = () => {
    setDownloading(true);
    ORBApi.downloadPaymentReportNotFoundTracks(report.id)
      .then((data) => {
        const file = new Blob([data], { type: `application/excel` });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(file);
        link.download = `ORB-not-found-tracks.xls`;
        link.click();
      })
      .then(() => {
        onDownload(true);
      })
      .catch(() => {
        onDownload(false);
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  const onPageChangeHandler = (page) => {
    loadReports(page);
  };

  const rebuildNotFoundTracks = () => {
    setRebuilding(true);
    ORBApi.rebuildPaymentReportNotFoundTracks(report.id)
      .then(() => {
        loadReports(1);
      })
      .finally(() => {
        setRebuilding(false);
      });
  };
  const loadReports = (page) => {
    ORBApi.loadPaymentReportNotFoundTracks(report.id, page).then((data) => {
      setTracksData(data);
    });
  };
  useEffect(() => {
    loadReports(1);
  }, []);

  return (
    <>
      <div className="update-logo">
        {rebuilding ? (
          <Loading size="25px" className="" />
        ) : (
          <Tooltip title="Atualiza lista de faixas não encontradas.">
            <UpdateRoundedIcon
              className="clickable"
              fontSize="large"
              color="secondary"
              onClick={rebuildNotFoundTracks}
            />
          </Tooltip>
        )}
      </div>
      <div className="excel-logo">
        {downloading ? (
          <Loading size="25px" className="download-loading" />
        ) : (
          <Tooltip title="Baixa a lista de faixas não encontradas em Excel.">
            <img
              src={excelLogo}
              className="clickable"
              onClick={downloadExcel}
            />
          </Tooltip>
        )}
      </div>
      <TableContainer className="base-table">
        <Table>
          <TableHead className="header">
            <TableRow>
              <TableCell>ISRC</TableCell>
              <TableCell>UPC</TableCell>
              <TableCell>Faixa</TableCell>
              <TableCell>Artista</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tracksData
              ? tracksData.tracks.map((track) => {
                  return (
                    <TableRow key={track.isrc}>
                      <TableCell>{track.isrc}</TableCell>
                      <TableCell>{track.upc}</TableCell>
                      <TableCell>{track.title}</TableCell>
                      <TableCell>{track.artist}</TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        shape="rounded"
        className="table-pagination"
        count={tracksData.pages}
        page={tracksData.current_page}
        onChange={(e, value) => {
          onPageChangeHandler(value);
        }}
      />
    </>
  );
}

export function MatchParcialTracksPanel({ report, onDownload }) {
  const [matchesData, setMatchesData] = useState({
    matches: [],
    pages: 0,
    current_page: 0,
    total_items: 0,
  });
  const [downloading, setDownloading] = useState(false);
  const [rebuilding, setRebuilding] = useState(false);

  const downloadExcel = () => {
    setDownloading(true);
    ORBApi.downloadPaymentParcialMatchesTracks(report.id)
      .then((data) => {
        const file = new Blob([data], { type: `application/excel` });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(file);
        link.download = `ORB-parcial-matches-tracks.xls`;
        link.click();
      })
      .then(() => {
        onDownload(true);
      })
      .catch(() => {
        onDownload(false);
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  const onPageChangeHandler = (page) => {
    loadReports(page);
  };

  const rebuildParcialMatchesTracks = () => {
    setRebuilding(true);
    ORBApi.rebuildPaymentReportParcialMatchesTracks(report.id)
      .then(() => {
        loadReports(1);
      })
      .finally(() => {
        setRebuilding(false);
      });
  };
  const loadReports = (page) => {
    ORBApi.loadPaymentReportParcialMatchesTracks(report.id, page).then(
      (data) => {
        setMatchesData(data);
      }
    );
  };
  useEffect(() => {
    loadReports(1);
  }, []);

  return (
    <>
      <div className="update-logo">
        {rebuilding ? (
          <Loading size="25px" className="" />
        ) : (
          <Tooltip title="Atualiza lista de faixas com match parcial.">
            <UpdateRoundedIcon
              className="clickable"
              fontSize="large"
              color="secondary"
              onClick={rebuildParcialMatchesTracks}
            />
          </Tooltip>
        )}
      </div>
      <div className="excel-logo">
        {downloading ? (
          <Loading size="25px" className="download-loading" />
        ) : (
          <Tooltip title="Baixa a lista de faixas com match parcial em Excel.">
            <img
              src={excelLogo}
              className="clickable"
              onClick={downloadExcel}
            />
          </Tooltip>
        )}
      </div>
      <TableContainer className="base-table">
        <Table>
          <TableHead className="header">
            <TableRow>
              <TableCell>UPC</TableCell>
              <TableCell>ISRC</TableCell>
              <TableCell>Faixa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {matchesData.matches
              ? matchesData.matches.map((track) => {
                  return (
                    <TableRow key={track.isrc}>
                      <TableCell>{track.upc}</TableCell>
                      <TableCell>{track.isrc}</TableCell>
                      <TableCell>{track.title}</TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        shape="rounded"
        className="table-pagination"
        count={matchesData.pages}
        page={matchesData.current_page}
        onChange={(e, value) => {
          onPageChangeHandler(value);
        }}
      />
    </>
  );
}
